<template>
    <tr v-if="projectItem">
        <td v-if="this.photoSelect">
            <a :href="projectItem.href" class="prod">
                <span class="img-cont">
                    <img v-bind:src=projectItem.picture alt="">
                </span>
            </a>
            <div class="tablet-stripe">
                <div>{{columns[1]}} {{projectItem.quantity}}</div>
                <div>{{columns[2]}} {{projectItem.unit}}</div>
                <template v-if="this.selfSelect == 'self'">
                    <div>{{columns[3]}} {{projectItem.retailPrice}}</div>
                    <div>{{columns[4]}} <span v-html="projectItem.optPrice"></span></div>
                    <div>{{columns[5]}} <span v-html="projectItem.retailAznPrice"></span></div>
                </template>
                <template v-else-if="this.selfSelect == 'client'">
                    <div>{{columns[3]}} <span v-html="projectItem.retailAznPrice"></span></div>
                </template>
                <template v-else-if="this.selfSelect == 'diler'">
                  <div>{{columns[3]}} <span v-html="projectItem.retailPrice"></span></div>
                </template>
                <template v-else-if="this.selfSelect == 'opt'">
                  <div>{{columns[3]}} <span v-html="projectItem.optPrice"></span></div>
                </template>
                <template v-else-if="this.selfSelect == 'retail'">
                  <div>{{columns[3]}} <span v-html="projectItem.retailAznPrice"></span></div>
                </template>
                <template v-else>
                  <div>{{columns[3]}} {{projectItem.retailPrice}}</div>
                  <div>{{columns[4]}} <span v-html="projectItem.optPrice"></span></div>
                  <div>{{columns[5]}} <span v-html="projectItem.retailAznPrice"></span></div>
                </template>
            </div>
        </td>
        <td>
          <a :href="projectItem.href" class="prod">
            {{projectItem.name}}
          </a>
        </td>
        <td>
            {{projectItem.quantity}}
        </td>
        <td>
            {{projectItem.unit}}
        </td>
        <td v-if="projectItem.retailPrice">
          <span v-html="projectItem.retailPrice"></span>
        </td>
        <td v-if="projectItem.optPrice">
          <span v-html="projectItem.optPrice"></span>
        </td>
        <td v-if="projectItem.retailAznPrice">
            <span v-html="projectItem.retailAznPrice"></span>
        </td>
        <td v-if="projectItem.retailPriceSum">
            <span class="mobile-label">{{columns[5]}}</span>
            <span v-html="projectItem.retailPriceSum"></span>
        </td>
        <td v-if="projectItem.optPriceSum">
            <span class="mobile-label">{{columns[6]}}</span>
            <span v-html="projectItem.optPriceSum"></span>
        </td>
        <td v-if="projectItem.retailAznPriceSum">
            <span class="mobile-label">{{columns[7]}}</span>
            <span v-html="projectItem.retailAznPriceSum"></span>
        </td>
        <td>
            <a @click="removeProduct(projectItem)" href="javascript:;" class="remove">
                <i class="demo-icon icon-union-50"></i>
            </a>
        </td>
    </tr>
</template>

<script>
    import {mapGetters} from 'vuex';

    /**
     * Компонент для отображения товара на странице корзины
     *
     * @vuedoc
     * @module vue:components/ProjectItem
     * @exports vue:components/ProjectItem
     */
    export default {
        name: "project-item",

        props: [
            'projectItem', 'project_id', 'currency', 'selfSelect', 'photoSelect', 'columns'
        ],

        data() {
            return {
                productId: this.product_id,
            }
        },

        computed: {

            ...mapGetters('project', [
                'projectItems', 'projectPrice'
            ]),

            getProjectPhoto: function () {
                if (this.projectItems.photo) {
                    return this.projectItems.photo;
                }
                return false;
            },
        },

        mounted() {
        },


        methods: {

            /**
             * Удаляем товар из проекта пользователя
             *
             * @method removeProduct
             */
            removeProduct(item) {
                if (this.project_id)
                    this.$store.dispatch('project/removeProduct', {productId: item.id, projectId: this.project_id, selfSelect: this.selfSelect});
                else
                    console.log("no project name");
            },
        }
    }


</script>
